import { combineReducers } from 'redux';
import RecipeDataReducer from './RecipeDataReducer';

const initialState = {
    showLoadingScreen: false
};

function rootReducer(state = initialState, action) {
    switch (action.type) {
        default:
            break;
    }

    return state;
}

export default combineReducers({
    rootReducer,
    RecipeDataReducer
});